import { createContext, ReactNode, useContext, useRef } from 'react';
import Notifications from '../components/molecules/Notifications';

type NotificationsContext = { getDynamicHeight: () => number };

const NotificationsContext = createContext<NotificationsContext>({} as any);

export const NotificationsProvider = ({ children }: { children: ReactNode }) => {
  const notificationsContainerRef = useRef<HTMLUListElement>(null);
  const getDynamicHeight = () => notificationsContainerRef.current?.clientHeight ?? 0;
  return (
    <>
      <Notifications containerRef={notificationsContainerRef} />
      <NotificationsContext.Provider value={{ getDynamicHeight }}>{children}</NotificationsContext.Provider>
    </>
  );
};

export const useNotifications = () => useContext(NotificationsContext);
